<template src="./index.html"></template>
<script>
	import data from './data.js';
	import zkdiag from './zkdiag/index.vue';
	import khinfo from './khinfo/index.vue';
	import copy from './copy/index.vue';
	import spinfo from './spinfo/index.vue';
	import fjxx from './fjxx/index.vue';
	import jbrinfo from './jbrinfo/index.vue';
	import drmx from './drmx/index.vue';
	import comMapping from '../../../../../comMapping';
	export default {
		components: {
			zkdiag,
			khinfo,
			spinfo,
			fjxx,
			jbrinfo,
			drmx,
			copy
		},
		props: {
			//红冲
			hongc: {
				type: Boolean,
				default: false
			},
			//是否可编辑
			disable: {
				type: Boolean,
				default: false
			},
			itemVlue: {
				type: String,
				default: '新增'
			},
			title: {
				//弹框编辑
				type: String,
				default: '单据录入-数电电子普票填开'
			},
			entering: {
				type: Boolean,
				default: false
			},
			id: {
				//弹框编辑
				type: String,
				default: ''
			},
			priceall: {
				//票面明细
				type: Array,
				default: function() {
					return [{}, {}, {}, {}, {}, {}, {}, {}];
				}
			},
			srk: {
				//附加内容
				type: Array,
				default: function() {
					return [];
				}
			},
			jbrdata: {
				//经办人信息
				type: Object,
				default: function() {
					return {
						xingm: '',
						guoj: '',
						zhengjlx: '',
						bank: '',
						qiybh: ''
					};
				}
			},
			ruleFormb: {
				//购方信息
				type: Object,
				default: function() {
					return {
						customerNumber: '', //客户编号
						customerName: '', //购买方名称
						shoupfzrrbs: false, //是否开票给自然人
						taxIdentificationNumber: '', //购买方纳税人识别号
						address: '', //购买方地 址、电 话
						zhengjhm: '' //购买方开户行及账号
					};
				}
			},
			ruleFormbxiao: {
				//销方信息 新增也要传
				type: Object,
				default: function() {
					return {
						name: '', //销售方名称
						taxNumber: '', //销售方名称纳税人识别号
						addressPhone: '', //销售方名称地 址、电 话
						bankAccount: '', //销售方名称开户行及账号
						bpayee: '', //收款人
						breview: '', //复 核
						bdrawer: '' //开票人
					};
				}
			},
			stateall: {
				//状态
				type: Object,
				default: function() {
					return {
						istaxincluded: false, //是否含税
						choosetitleindex: '' //发票类型 新增也要传
					};
				}
			},
			totalall: {
				//合计
				type: Object,
				default: function() {
					return {
						pricetotal: '',
						jiastotal: '',
						jiastotalda: '',
						taxtotal: ''
					};
				}
			},
			tdywxz: {
				//特定业务
				type: String,
				default: ''
			},
			cezsxz: {
				//差额征税
				type: String,
				default: ''
			},
			jazsxz: {
				//减按征税
				type: String,
				default: ''
			},
			danjh: {
				//单据号
				type: String,
				default: ''
			},
			bztext: {
				//备注
				type: String,
				default: ''
			},
			kaipr: {
				//开票人
				type: String,
				default: ''
			},
			tedxx: {
				//特定信息
				type: Object,
				default: function() {
					return {
						qiybh: '',
						jianzfwfsd: '',
						fasdxxdz: '',
						jianzxmmc: '',
						tudzzsxmbh: '',
						budcdz: '',
						budcxxdz: '',
						zulqqzulqz: ['', ''],
						kuadsbz: '',
						budcqzhm: '',
						mianjdw: ''
					};
				}
			},
			fuhr: {
				//复核人
				type: String,
				default: ''
			},
			shoukr: {
				//收款人
				type: String,
				default: ''
			},
		},
		data() {
			return {
				RegionData: data.RegionData,
				comMapping: comMapping,
				/* 头部相关 */
				stateall: {
					istaxincluded: false //是否含税
				},
				tdywoptions: data.tdywoptions,
				cezsoptions: data.cezsoptions,
				jazsoptions: data.jazsoptions,
				zjlxoptions: data.zjlxoptions,
				/* 头部相关 */
				/* 票面明细相关 */
				isIndeterminate: true /* 全选票列表状态 */ ,
				taxRateoptions: [{
					label: '6%',
					value: '0.06'
				}], //税率集合
				checkAll: false, //是否全选
				deleteindexs: [], //发票选中index集合
				checkList: [], //发票选中集合
				priceallchooseindex: '', //票面选中索引
				tableData_picNameall: [],
				dialogFormVisible_Name: false, //唤醒客户主数据
				HandlingPersonInformation_Name: false, //唤醒经办人信息
				dialogVisible_pic: false, //唤醒商品主数据
				xunzfjxx: false, //唤醒附加内容添加
				importtk: false, //唤醒导入明细界面
				copy_Name: false, //唤醒复制界面
				Region: false, //唤醒地区选择弹框
				//表格拖拽
				draggable: false, //是否可拖拽
				ending: null,
				dragging: null,
				/* 票面明细相关 */
				/* 折扣行相关 */
				zkhang: 0 /* 点击折扣行算出的总行数 */ ,
				zktotal: 0 /* 点击折扣行算出的总金额 */ ,
				dialogVisible_reduce: false,
				/* 折扣行相关 */

				//以下暂时我未用
				options: [],
				cjmb: '',
				activeNames: ["1"],
				state: '',
				//特定业务
				isjytdyw: false,
				//差额征税
				isjycezs: false,
				//减按征税
				isjyjazs: false,
				//判断展示特定业务
				istdyw: '',
				//选择的地区
				xuzRegionData: [],
			};
		},
		created() {},
		mounted() {},
		watch: {
			entering: function(indexVal, oldVal) {
				if (indexVal) {
					// this.RegionData = [];
					// this.RegionData =data.RegionData.map(v1=>{
					// 	return{
					// 		value: v1.name,
					// 		label: v1.name,
					// 		children:v1.city.map(v2=>{
					// 			return {
					// 				value: v2.name,
					// 				label: v2.name,
					// 				children:v2.area.map(v3=>{
					// 					return {
					// 						value: v3,
					// 						label: v3,
					// 					}
					// 				})
					// 			}
					// 		})
					// 	}
					// })
					// console.log(this.RegionData)

					//此处做初始化逻辑
					// 查询
					this.huoqcjmb(); //查询场景模板
					this.gettableData_picNameall(); //查询购方信息
					this.getCurHdkpsl(); //获取税率
					if (
						this.title == '单据录入-数电电子普票填开' ||
						this.title == '单据录入-数电电子专票填开' ||
						this.title == '单据录入-数电纸质专票填开' ||
						this.title == '单据录入-数电纸质普票填开'
					) {
						this.relese(); //如果是新增则清空界面
						//初始化开票人
						this.kaipr = this.ruleFormbxiao.bdrawer;
					}
					this.activeNames = ["1"]; //清空
				}
			},
			cjmb: function(indexVal, oldVal) {
				this.srk = [];
				if (indexVal) {
					for (var i = 0; i < this.options.length; i++) {
						if (this.options[i].id == indexVal) {
							this.srk = this.options[i].addInformItemVos;
						}
					}
				}
			},
			tdywxz: function(indexVal, oldVal) {
				if (indexVal == '03') {
					this.jazsoptions = data.jazsoptions;
					this.istdyw = '1';
				} else if (indexVal == '06') {
					this.jazsoptions = [{
						value: '2',
						label: '住房租赁'
					}];
					if (this.jazsxz != '') {
						this.jazsxz = '2';
					}
					this.istdyw = '2';
				} else {
					this.istdyw = '';
					this.jazsoptions = data.jazsoptions;
				}

				if (indexVal == '03') {
					this.isjyjazs = true;
					this.jazsxz = '';
				} else if (indexVal != '03' && this.cezsxz == '') {
					this.isjyjazs = false;
				}
			},
			cezsxz: function(indexVal, oldVal) {
				if (indexVal != '') {
					this.isjyjazs = true;
					this.jazsxz = '';
				} else if (indexVal == '' && this.tdywxz != '03') {
					this.isjyjazs = false;
				}
			},
			jazsxz: function(indexVal, oldVal) {
				if (indexVal != '') {
					this.isjycezs = true;
					this.cezsxz = '';
				} else {
					this.isjycezs = false;
				}
			}
		},
		methods: {
			Regiontk() {
				this.xuzRegionData = [];
				this.Region = true;
			},
			Region_guanbi() {
				this.Region = false;
			},
			Regionqued() {
				if (this.xuzRegionData == []) {
					this.$message.error('请选择地区');
					return false;
				}
				this.tedxx.jianzfwfsd = '';
				this.tedxx.budcdz = '';
				let working = '';
				if (this.istdyw == '1') {
					this.xuzRegionData.forEach(v => {
						if (working == '') {
							working = v;
							this.tedxx.jianzfwfsd += v;
						}
						if (working != v) {
							this.tedxx.jianzfwfsd += v;
						}
					});
				} else if (this.istdyw == '2') {
					this.xuzRegionData.forEach(v => {
						if (working == '') {
							working = v;
							this.tedxx.budcdz += v;
						}
						if (working != v) {
							this.tedxx.budcdz += v;
						}
					});
				}
				this.Region = false;
			},
			// 清空页面数据
			relese() {
				this.priceall = [{}, {}, {}, {}, {}, {}, {}, {}];
				Object.keys(this.totalall).map(key => (this.totalall[key] = ''));
				Object.keys(this.ruleFormb).map(key => {
					if (key == 'shoupfzrrbs') {
						this.ruleFormb[key] = false
					} else {
						this.ruleFormb[key] = ''
					}
				});
				this.deleteindexs = [];
				this.checkList = [];
				this.bztext = '';
				this.totalall.pricetotal = '';
				this.totalall.jiastotal = '';
				this.tdywxz = '';
				this.cezsxz = '';
				this.jazsxz = '';
				this.tedxx = {
					qiybh: '',
					jianzfwfsd: '',
					fasdxxdz: '',
					jianzxmmc: '',
					kuadsbz: '',
					budcdz: '',
					budcxxdz: '',
					zulqqzulqz: ['', ''],
					kuadsbz: '',
					budcqzhm: '',
					mianjdw: ''
				};
				this.cjmb = ''
				this.id = '';
				this.danjh = '';
				this.srk = [];
				this.kaipr = '';
				this.fuhr = '';
				this.shoukr = '';
				this.jbrdata = {
					xingm: '',
					guoj: '',
					zhengjlx: '',
					bank: '',
					qiybh: ''
				};
			},
			//获取场景模板
			huoqcjmb() {
				let patea = {
					limit: 1000000,
					page: 1,
					param: {}
				};
				this.$https.fetchPost('felec/addInformMaintain/getScenarioTemplatesByCode', patea).then(res => {
					if (res.data.code == '200') {
						res.data.data.sort(function(a, b) {
							return a.id - b.id;
						});
						this.options = res.data.data;
					} else {
						this.$message.error('失败');
					}
				});
			},
			//删除模板输入行
			deletmb(k) {
				this.srk.splice(k, 1);
			},
			returnrke(v) {
				v.forEach(dat => {
					let pand = true;
					this.srk.forEach(datsrk => {
						if (dat.fujxxmc == datsrk.fujxxmc) {
							pand = false;
						}
					});
					if (pand) {
						this.srk.push(dat);
					}
				});
			},
			/* 票面操作 */
			//数据提交
			handleSave() {
				if (this.stateall.choosetitleindex != '026' && this.stateall.choosetitleindex != '007') {
					if (this.ruleFormb.taxIdentificationNumber.search('S') != -1) {
						this.$message.error('纳税人识别号不能存在S');
						return false;
					} else if (this.ruleFormb.taxIdentificationNumber.search('O') != -1) {
						this.$message.error('纳税人识别号不能存在O');
						return false;
					} else if (this.ruleFormb.taxIdentificationNumber.search('V') != -1) {
						this.$message.error('纳税人识别号不能存在V');
						return false;
					} else if (this.ruleFormb.taxIdentificationNumber.search('I') != -1) {
						this.$message.error('纳税人识别号不能存在I');
						return false;
					} else if (this.ruleFormb.taxIdentificationNumber.search('Z') != -1) {
						this.$message.error('纳税人识别号不能存在Z');
						return false;
					} else if (this.ruleFormb.taxIdentificationNumber.length == 0) {
						this.$message.error('纳税人识别号不能为空');
						return false;
					} else if (this.ruleFormb.taxIdentificationNumber != this.ruleFormb.taxIdentificationNumber
						.toUpperCase()) {
						this.$message.error('纳税人识别号不能存在小写字母');
						return false;
					} else if (this.ruleFormb.taxIdentificationNumber.length != 18 && this.ruleFormb
						.taxIdentificationNumber.length != 20) {
						this.$message.error('纳税人识别号字数必须在18位和20位');
						return false;
					}
				}
				if (this.bztext) {
					if (this.GetLength(this.bztext) > 230) {
						this.$message.error('备注字数不能超出限制');
						return false;
					}
				}

				if (this.istdyw == '1') {
					if (this.tedxx.jianzfwfsd == '') {
						this.$message.error('请输入建筑服务发生地');
						return false;
					}
					if (this.tedxx.fasdxxdz == '') {
						this.$message.error('请输入详细地址');
						return false;
					}
					if (this.tedxx.jianzxmmc == '') {
						this.$message.error('请输入建筑项目名称');
						return false;
					}
					if (this.tedxx.kuadsbz == '') {
						this.$message.error('请选择跨地(市)标志');
						return false;
					}
				} else if (this.istdyw == '2') {
					if (this.tedxx.budcdz == '') {
						this.$message.error('请输入不动产地址');
						return false;
					}
					if (this.tedxx.zulqqzulqz.length < 2) {
						this.$message.error('请输入租赁期起止');
						return false;
					}
					if (this.tedxx.budcxxdz == '') {
						this.$message.error('请输入详细地址');
						return false;
					}
					if (this.tedxx.kuadsbz == '') {
						this.$message.error('请选择跨地(市)标志');
						return false;
					}
					if (this.tedxx.budcqzhm == '') {
						this.$message.error('请输入产权证书/不动产权证号');
						return false;
					}
					if (this.tedxx.mianjdw == '') {
						this.$message.error('请输入面积单位');
						return false;
					}
				}
				if (this.kaipr == '' || this.kaipr == null) {
					this.$message.error('请输入开票人名称');
					return false;
				}
				for (var i = 0; i < this.srk.length; i++) {
					if (this.srk[i].deit == '' || this.srk[i].deit == undefined || this.srk[i].deit == null) {
						this.$message.error('请输入附加信息');
						return false;
					}
				}
				let newpriceall = JSON.parse(JSON.stringify(this.priceall));
				if (newpriceall) {
					for (let i = 0; i < newpriceall.length; i++) {
						if (newpriceall[i].goodsName == null || newpriceall[i].goodsName == '' || JSON.stringify(
								newpriceall[i]) == '{}') {
							newpriceall.splice(i, 1);
							i = i - 1;
						}
					}
					newpriceall.forEach((item, index) => {
						item.quantity = item.quantity == 0 ? '' : item.quantity;
						item.unitPrice = item.unitPrice == 0 ? '' : item.unitPrice;
						item.chooseMoney = item.chooseMoney == 0 ? '' : item.chooseMoney;
						// item.taxRate = item.taxRate == 0 ? '' : item.taxRate;
						item.taxRatemoney = item.taxRatemoney == '' ? 0 : item.taxRatemoney;
						item.itemNo = index + 1;
					});
				}
				let thing = {
					stateall: this.stateall, //所有状态
					ruleFormb: this.ruleFormb, //购买方信息
					priceall: newpriceall, //发票明细信息
					totalall: this.totalall, //合计
					ruleFormbxiao: this.ruleFormbxiao, //销方信息
					bztext: this.bztext, //备注信息
					tdywxz: this.tdywxz, //特定业务
					cezsxz: this.cezsxz, //差额征税
					jazsxz: this.jazsxz, //减按征税
					srk: this.srk, //附加内容
					jbrdata: this.jbrdata, //经办人信息
					tedxx: this.tedxx, //特定信息
					id: this.id,
					danjh: this.danjh,
					kaipr: this.kaipr,
					doc: {
						fuhr: this.fuhr,
						shoukr: this.shoukr
					},
				};
				this.$emit('InvoiceBackInformation', thing);
			},

			hongcClick() {
				this.$emit('InvoiceBackInformation', this.id);
			},
			//拖拽相关
			fordrgain() {
				this.draggable = !this.draggable;
				if (this.draggable) {
					this.$message.info('请直接拖动票面明细进行调整');
				}
			},
			handleDragStart(e, index) {
				this.dragging = index;
			},
			handleDragEnd(e, item) {
				if (this.priceall[this.dragging].type == 1 || this.priceall[this.ending].type == 1) {
					this.$message.error('只能拖动和移动至非折扣行');
					return false;
				}
				let newItems = JSON.parse(JSON.stringify(this.priceall));
				let obj = {
					type: 8,
					goodsName: 'test'
				};
				var startindex = this.dragging;
				var endindex = this.ending;
				if (newItems[startindex].type == '2' || newItems[endindex].type == '2') {
					if (newItems[startindex].type != '2') {
						newItems.splice(startindex, 0, obj);
						if (startindex < endindex) {
							endindex = parseFloat(endindex) + 1;
						}
					}
					if (newItems[endindex].type != '2') {
						newItems.splice(endindex, 0, obj);
						if (endindex < startindex) {
							startindex = parseFloat(startindex) + 1;
						}
					}
					newItems.splice(startindex, 2, ...newItems.splice(endindex, 2, newItems[startindex], newItems[
						startindex + 1]));
				} else {
					newItems.splice(startindex, 1, ...newItems.splice(endindex, 1, newItems[startindex]));
				}
				newItems.forEach((item, index) => {
					if (item.type == 8) {
						newItems.splice(index, 1);
					}
				});
				this.dragging = null;
				this.ending = null;
				this.priceall = JSON.parse(JSON.stringify(newItems));
			},
			handleDragOver(e, item) {
				e.dataTransfer.dropEffect = 'move';
			},
			handleDragEnter(e, index) {
				this.ending = index;
			},
			// 获取税率
			getCurHdkpsl() {
				let params = {
					faplx: this.stateall.choosetitleindex
				};
				this.$https.fetchPost('/invoice/issueInfo/getCurHdkpsl', params).then(res => {
					this.taxRateoptions = res.data.obj;
				});
			},
			//获取到发票明细用户选中的索引
			checkchange(chooselist) {
				this.deleteindexs = chooselist.map(item => item - 1);
			},
			//发票全选操作
			handleCheckAllChange(val) {
				if (val) {
					let arr = [];
					this.priceall.forEach((item, index) => {
						arr.push(index + 1);
					});
					this.checkList = arr;
					this.deleteindexs = this.checkList.map(item => item - 1);
				} else {
					this.deleteindexs = [];
					this.checkList = [];
				}
				this.isIndeterminate = false;
			},
			//商品主数据弹出
			picfn(index) {
				this.priceallchooseindex = index;
				this.dialogVisible_pic = true;
			},
			closedialogVisible_pic() {
				this.dialogVisible_pic = false;
			},
			forsurezhu(chooseallsp) {
				console.log(chooseallsp);
				if (this.stateall.istaxincluded) {
					chooseallsp.unitPrice = (parseFloat(chooseallsp.taxRate) + 1) * chooseallsp.unitPrice;
					if (chooseallsp.unitPrice == 0) {
						chooseallsp.unitPrice = '';
					}
				}
				this.priceall[this.priceallchooseindex] = chooseallsp;
				if (chooseallsp.taxRate == 0.0) {
					chooseallsp.taxRate = '0';
				}
				this.changevaluequantity(this.priceall[this.priceallchooseindex]);
				this.closedialogVisible_pic();
			},

			// 增加行
			addmore() {
				this.priceall.push({});
			},
			// 删除行
			deletemore() {
				if (this.deleteindexs.length == 0) {
					this.$message.info('请选择要删除的条目');
					return false;
				}
				var isdelete = false;
				this.deleteindexs.forEach(gtem => {
					if (this.priceall[gtem].type == '2') {
						isdelete = true;
					}
				});
				if (isdelete) {
					this.$message.error('存在折扣行的正数行无法删除');
					return false;
				}
				this.deleteindexs.forEach(gtem => {
					if (this.priceall[gtem].type == '1') {
						//如果存在折扣行且折扣行已被删除的情况下，恢复上级状态
						if (gtem > 0) {
							this.priceall[gtem - 1].type = '';
						}
					}
				});
				this.priceall = this.priceall.filter((item, index) => !this.deleteindexs.includes(index));
				this.deleteindexs = [];
				this.checkList = [];
				this.totoalamount();
			},
			//折扣行
			reducemore() {
				if (this.deleteindexs.length == 0) {
					this.$message.info('请先选择明细行');
					return false;
				}
				let arrcount = 0;
				let runall = false;
				let errorall = false;
				let shulerr = false;
				this.priceall.forEach((item, index) => {
					this.deleteindexs.forEach(gtem => {
						if (index == gtem) {
							if (item.type == 1 || item.type == 2) {
								runall = true;
							}
							if (item.chooseMoney == '' || item.chooseMoney == null) {
								errorall = true;
							}
							if (!(item.taxRate > 0)) {
								shulerr = true;
							}
							arrcount = parseFloat(item.chooseMoney) + arrcount;
						}
					});
				});
				if (runall) {
					this.$message.info('选中行已含有折扣行或者选中了折扣行');
					return false;
				}
				if (errorall) {
					this.$message.info('选中行金额不能为空');
					return false;
				}
				if (shulerr) {
					this.$message.info('税率不能为空');
					return false;
				}
				this.zktotal = arrcount;
				this.zkhang = this.deleteindexs.length;
				this.dialogVisible_reduce = true;
			},
			//折扣行保存
			forsavezk(form_money) {
				console.log(form_money);
				console.log((form_money.DiscountRate / 100));
				var pricetatal = 0;
				this.priceall.forEach((item, index) => {
					if (this.notemptyandnull(item.goodsName)) {
						if (this.deleteindexs.indexOf(index) != -1) {
							pricetatal = pricetatal + parseFloat(item.chooseMoney);
						}
					}
				});
				if (parseFloat(form_money.DiscountMoney) > pricetatal) {
					this.$message.error('折扣金额不能大于明细总金额');
					return false;
				}
				let useAmount = 0;
				this.deleteindexs.reverse();
				this.deleteindexs.forEach(item => {
					this.priceall[item].type = '2';
					var newtaxratemoney;
					if (this.stateall.istaxincluded) {
						newtaxratemoney =
							0 - (this.priceall[item].chooseMoney / (1 + parseFloat(this.priceall[item].taxRate)) *
								this.priceall[item].taxRate * (form_money.DiscountRate / 100));
					} else {
						newtaxratemoney =
							0 -
							(this.priceall[item].unitPrice * (this.priceall[item].quantity || 1) || this.priceall[
								item].chooseMoney) *
							this.priceall[item].taxRate *
							(form_money.DiscountRate / 100);
					}
					let curAmount = 0 - (this.priceall[item].chooseMoney * (form_money
							.DiscountRate / 100)).toFixed(2);

					if(item == 0) {
						curAmount = (0 - parseFloat(form_money.DiscountMoney) - parseFloat(useAmount)).toFixed(2);
						if (this.stateall.istaxincluded) {
							newtaxratemoney = (curAmount / (1 + parseFloat(this.priceall[item].taxRate)))*this.priceall[item].taxRate;
						} else {
							newtaxratemoney = curAmount*this.priceall[item].taxRate;
						}
					}
					this.priceall.splice(item + 1, 0, {
						taxCode: this.priceall[item].taxCode,
						goodsName: this.priceall[item].goodsName,
						type: '1',
						chooseMoney: curAmount, //金额
						taxRate: this.priceall[item].taxRate, //税率
						taxRatemoney: this.Amountformat(newtaxratemoney) //税额
					});

					useAmount += parseFloat(curAmount);
				});

				for (let i = 0; i < this.priceall.length; i++) {
					if (this.emptyandnull(this.priceall[i].goodsName) & (this.deleteindexs.length > 0)) {
						this.priceall.splice(i, 1);
						this.deleteindexs.pop();
					}
				}
				this.totoalamount();
				this.closedialogVisible_reduce();
			},
			//折扣行弹框关闭
			closedialogVisible_reduce() {
				this.dialogVisible_reduce = false;
			},
			//合计计算
			totoalamount() {
				let total = 0;
				let shuietotal = 0;
				for (let i = 0; i < this.priceall.length; i++) {
					if ((this.priceall[i].chooseMoney != '') & (this.priceall[i].chooseMoney != null)) {
						total = parseFloat(this.priceall[i].chooseMoney) + total;
					}
					if ((this.priceall[i].taxRatemoney != '') & (this.priceall[i].taxRatemoney != null)) {
						shuietotal = parseFloat(this.priceall[i].taxRatemoney) + shuietotal;
					}
				}
				this.totalall.taxtotal = this.Amountformat(shuietotal);
				if (this.stateall.istaxincluded) {
					this.totalall.jiastotal = this.Amountformat(total);
					this.totalall.pricetotal = this.Amountformat(total - parseFloat(this.totalall.taxtotal));
				} else {
					this.totalall.pricetotal = this.Amountformat(total);
					this.totalall.jiastotal = this.Amountformat(total + parseFloat(this.totalall.taxtotal));
				}
				this.totalall.jiastotalda = this.pricetonew(this.totalall.jiastotal);
			},
			/* 计算税额 */
			amountTaxmoneybytaxRate(item, index) {
				if (this.stateall.istaxincluded) {
					item.taxRatemoney = item.taxRate * (item.chooseMoney / (1 + parseFloat(item.taxRate)));
				} else {
					item.taxRatemoney = item.chooseMoney * item.taxRate;
				}
				item.taxRatemoney = item.taxRatemoney == '' ? '0' : this.Amountformat(item.taxRatemoney);
			},
			/* 计算单价 */
			amountcount(item, index) {
				if (this.stateall.istaxincluded) {
					item.unitPrice = item.chooseMoney / item.quantity;
				} else {
					item.unitPrice = (item.chooseMoney * (1 + parseFloat(item.taxRate))) / (1 + parseFloat(item.taxRate)) /
						item.quantity;
				}
				let charLength = String(item.unitPrice).substring(String(item.unitPrice).lastIndexOf('.') + 1).length;
				if (charLength > 10) {
					item.unitPrice = parseFloat(item.unitPrice.toFixed(10));
				}
			},
			// 计算数量
			amountquantity(item, index) {
				if (this.stateall.istaxincluded) {
					item.quantity = item.chooseMoney / item.unitPrice;
				} else {
					item.quantity = (item.chooseMoney * (1 + parseFloat(item.taxRate))) / (1 + parseFloat(item.taxRate)) /
						item.unitPrice;
				}
				let charLength = String(item.quantity).substring(String(item.quantity).lastIndexOf('.') + 1).length;
				if (charLength > 10) {
					item.quantity = parseFloat(item.quantity.toFixed(10));
				}
			},
			/* 计算金额 */
			amoutchooseMoney(item, index) {
				if (this.emptyandnull(item.quantity) || this.emptyandnull(item.unitPrice)) {
					item.chooseMoney = '';
					return false;
				}
				if (this.stateall.istaxincluded) {
					item.chooseMoney = item.quantity * item.unitPrice;
				} else {
					item.chooseMoney = ((1 + parseFloat(item.taxRate)) * item.quantity * item.unitPrice) / (1 + parseFloat(
						item.taxRate));
				}
				item.chooseMoney = item.chooseMoney == '' ? '0' : this.Amountformat(item.chooseMoney);
			},
			/* 改变数量 */
			changevaluequantity(item, index) {
				let arr = item.quantity.split('.');
				if (arr.length == 2 && arr[1].length > 10) {
					item.quantity = arr[0] + '.' + arr[1].substring(0, 10);
				}
				console.log(item.quantity);
				if (this.emptyandnull(item.unitPrice)) {
					if (this.notemptyandnull(item.chooseMoney)) {
						this.amountcount(item, index);
					}
				} else {
					this.amoutchooseMoney(item, index);
					this.amountTaxmoneybytaxRate(item, index);
					this.totoalamount();
				}
				this.$forceUpdate();
			},
			/* 改变单价 */
			changevalueunitPrice(item, index) {
				let arr = item.unitPrice.split('.');
				if (arr.length == 2 && arr[1].length > 10) {
					item.unitPrice = arr[0] + '.' + arr[1].substring(0, 10);
				}
				if (this.emptyandnull(item.quantity)) {
					if (this.notemptyandnull(item.chooseMoney)) {
						this.amountquantity(item, index);
					}
				} else {
					this.amoutchooseMoney(item, index);
					this.amountTaxmoneybytaxRate(item, index);
					this.totoalamount();
				}
				this.$forceUpdate();
			},
			/* 改变金额 */
			changevaluechooseMoney(item, index) {
				console.log(item);
				let arr = item.chooseMoney.split('.');
				if (arr.length == 1 && arr[0] != '') {
					item.chooseMoney = arr[0] + '.00';
				}
				if (this.emptyandnull(item.quantity)) {
					if (this.notemptyandnull(item.unitPrice)) {
						this.amountquantity(item, index);
					}
				} else {
					this.amountcount(item, index);
				}
				this.amountTaxmoneybytaxRate(item, index);
				this.totoalamount();
				this.$forceUpdate();
			},
			/* 改变税率 */
			changevaluetaxRate(item, index) {
				if (this.notemptyandnull(item.chooseMoney)) {
					this.amountTaxmoneybytaxRate(item, index);
				}
				this.totoalamount();
				this.$forceUpdate();
			},
			/* 金额单价数量的输入校验 */
			chooseMoneyChange(item, index) {
				if (item.chooseMoney < 0) {
					item.chooseMoney = 0;
				}
				let arr = item.chooseMoney.split('.');
				if (arr.length == 2 && arr[1].length > 2) {
					item.chooseMoney = arr[0] + '.' + arr[1].substring(0, 2);
				}
				this.$forceUpdate();
			},
			chooseUnitPriceChange(item, index) {
				if (item.unitPrice < 0) {
					item.unitPrice = 0;
				}
				let arr = item.unitPrice.split('.');
				if (arr.length == 2 && arr[1].length > 10) {
					item.unitPrice = arr[0] + '.' + arr[1].substring(0, 10);
				}
				this.$forceUpdate();
			},
			choosequantityChange(item, index) {
				if (item.quantity < 0) {
					item.quantity = 0;
				}
				let arr = item.quantity.split('.');
				if (arr.length == 2 && arr[1].length > 10) {
					item.quantity = arr[0] + '.' + arr[1].substring(0, 10);
				}
				this.$forceUpdate();
			},
			/* 金额单价数量的输入校验 */

			//是否含税模式变更
			changeincluded() {
				this.pricealltaxchange();
				this.totoalamount();
			},
			//含税变更逻辑
			pricealltaxchange() {
				this.priceall.forEach((item, index) => {
					if ((item.type != 1) & this.notemptyandnull(item.chooseMoney)) {
						if (this.stateall.istaxincluded) {
							item.chooseMoney = parseFloat(item.chooseMoney) + parseFloat(item.taxRatemoney);
							if (this.notemptyandnull(item.unitPrice)) {
								item.unitPrice = item.chooseMoney / item.quantity;
								let charLength = String(item.unitPrice).substring(String(item.unitPrice)
									.lastIndexOf('.') + 1).length;
								if (charLength > 10) {
									item.unitPrice = parseFloat(item.unitPrice.toFixed(10));
								}
							}
						} else {
							if (this.notemptyandnull(item.unitPrice)) {
								item.unitPrice = item.chooseMoney / (1 + parseFloat(item.taxRate)) / item.quantity;
								let charLength = String(item.unitPrice).substring(String(item.unitPrice)
									.lastIndexOf('.') + 1).length;
								if (charLength > 10) {
									item.unitPrice = parseFloat(item.unitPrice.toFixed(10));
								}
							}
							item.chooseMoney = item.chooseMoney / (1 + parseFloat(item.taxRate));
						}
						item.chooseMoney = this.Amountformat(item.chooseMoney);
					}
				});
				/* 	根据状态变更计算折扣行 */
				this.priceall.forEach((item, index) => {
					if (item.type == 1) {
						if (this.stateall.istaxincluded) {
							item.chooseMoney =
								(item.chooseMoney / (parseFloat(this.priceall[index - 1].chooseMoney) - parseFloat(
									this.priceall[index - 1].taxRatemoney))) *
								this.priceall[index - 1].chooseMoney;
						} else {
							item.chooseMoney =
								(item.chooseMoney / (parseFloat(this.priceall[index - 1].chooseMoney) + parseFloat(
									this.priceall[index - 1].taxRatemoney))) *
								this.priceall[index - 1].chooseMoney;
						}
						item.chooseMoney = this.Amountformat(item.chooseMoney);
					}
				});
			},
			/* 购方信息 */
			// 搜索购买方数据
			gettableData_picNameall() {
				let params = {};
				this.$https.fetchPost('/master/getAllCustomerList', params).then(res => {
					this.tableData_picNameall = res.data.data;
				});
			},
			handleSelectcustomer(item) {
				this.ruleFormb.address = item.address;
				this.ruleFormb.customerNumber = item.customerNumber;
				this.ruleFormb.customerName = item.customerName;
				this.ruleFormb.taxIdentificationNumber = item.taxIdentificationNumber;
				this.ruleFormb.bank = item.bank;
				// this.ruleFormb = item;
			},
			nameall(queryString, cb) {
				this.tableData_picNameall.forEach(item => {
					item.value = item.customerName;
				});
				var restaurants = this.tableData_picNameall;
				var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
				cb(results);
			},
			createFilter(queryString) {
				return restaurant => {
					return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
				};
			},
			// 长度提示
			writegz(e) {
				if (e.value.length == 66) {
					this.$message.info('字符超过66位可能打印时无法展示所有内容');
				}
			},
			//复制界面
			closecopy_Name() {
				this.copy_Name = false;
			},
			copytk() {
				this.copy_Name = true;
			},
			copytkfade(e) {
				// this.relese();
				console.log(e);

				//发票明细
				this.priceall = [];
				for (var i = 0; i < e.detailVos.length; i++) {
					if (e.detailVos[i].faphxz == '1') {
						this.priceall.push({
							taxCode: e.detailVos[i].shuisbm,
							goodsName: e.detailVos[i].shangpmc,
							chooseMoney: e.detailVos[i].jine,
							taxRate: e.detailVos[i].shuil,
							taxRatemoney: e.detailVos[i].shuie,
							itemNo: e.detailVos[i].hangh,
							type: 1
						});
					} else {
						this.stateall.istaxincluded = e.detailVos[i].hansbz == 1 ? true : false;
						this.priceall.push({
							unitPrice: e.detailVos[i].danj,
							unit: e.detailVos[i].danw,
							spec: e.detailVos[i].guigxh,
							itemNo: e.detailVos[i].hangh,
							chooseMoney: e.detailVos[i].jine,
							taxCode: e.detailVos[i].shuisbm,
							goodsName: e.detailVos[i].shangpmc,
							quantity: e.detailVos[i].shangpsl,
							taxRatemoney: e.detailVos[i].shuie,
							taxRate: e.detailVos[i].shuil,
							type: e.detailVos[i].faphxz
						});
					}
				}

				//开票人
				this.kaipr = e.doc.kaipr;
				//备注
				this.bztext = e.doc.beiz;
				//购方信息
				this.ruleFormb.address = e.doc.goufdzdh;
				this.ruleFormb.customerNumber = e.doc.customerNo;
				this.ruleFormb.customerName = e.doc.goufmc;
				this.ruleFormb.taxIdentificationNumber = e.doc.goufsbh;
				this.ruleFormb.bank = e.doc.goufyhzh;
				this.ruleFormb.shoupfzrrbs = e.doc.shoupfzrrbs;
				//销方
				this.ruleFormbxiao.addressPhone = e.doc.xiaofdzdh;
				this.ruleFormbxiao.name = e.doc.xiaofmc;
				this.ruleFormbxiao.taxNumber = e.doc.xiaofsbh;
				this.ruleFormbxiao.bankAccount = e.doc.xiaofyhzh;
				//经办人信息
				this.jbrdata.xingm = e.doc.goufjbrxm;
				this.jbrdata.zhengjhm = e.doc.goumfjbrzjhm;
				this.jbrdata.zhengjlx = e.doc.goumfjbrzjlx;
				this.jbrdata.guoj = e.doc.jinbrgj;
				this.jbrdata.qiybh = e.doc.jinbrzrrnsrsbh;
				//特定业务
				this.tdywxz = e.doc.tedywlx == null ? '' : e.doc.tedywlx;
				//差额征税 减按征税
				this.cezsxz = e.doc.chaezslx == null ? '' : e.doc.chaezslx;
				this.jazsxz = e.doc.jianazs == null ? '' : e.doc.jianazs;
				//合计
				this.totalall.pricetotal = e.doc.hejje;
				this.totalall.taxtotal = e.doc.hejse;
				this.totalall.jiastotal = e.doc.jiashj;
				this.totalall.jiastotalda = this.pricetonew(this.totalall.jiastotal);
				//特定业务类型
				if (e.specificBusinessData != null) {
					this.tedxx = e.specificBusinessData;
					this.tedxx.zulqqzulqz = ['', ''];
					this.tedxx.zulqqzulqz[0] = e.specificBusinessData.zulqq;
					this.tedxx.zulqqzulqz[1] = e.specificBusinessData.zulqz;
				}
				//附加内容
				for (var i = 0; i < e.additionalElementsVos.length; i++) {
					this.srk.push({
						fujxxmc: e.additionalElementsVos[i].fujysmc,
						deit: e.additionalElementsVos[i].fujysnr,
						shujlx: e.additionalElementsVos[i].shujlx
					});
				}
				this.copy_Name = false;
			},

			//客户主数据
			closedialogFormVisible_Name() {
				this.dialogFormVisible_Name = false;
			},
			foropenkh() {
				this.dialogFormVisible_Name = true;
			},
			forsurekh(e) {
				// this.ruleFormb = e;
				this.ruleFormb.address = e.address;
				this.ruleFormb.customerNumber = e.customerNumber;
				this.ruleFormb.customerName = e.customerName;
				this.ruleFormb.taxIdentificationNumber = e.taxIdentificationNumber;
				this.ruleFormb.bank = e.bank;
				this.closedialogFormVisible_Name();
			},
			//经办人信息
			closedHandlingPersonInformation_Name() {
				this.HandlingPersonInformation_Name = false;
			},
			choice() {
				this.HandlingPersonInformation_Name = true;
			},
			Handling(e) {
				this.jbrdata = e;
				this.closedHandlingPersonInformation_Name();
			},
			//选择附加信息
			closexunzfjxx(v) {
				this.xunzfjxx = false;
			},
			fujlrtk() {
				this.xunzfjxx = true;
			},
			/* 纳税人识别号验证 */
			nashuigz(e) {
				console.log();
				if (e.search('S') != -1) {
					this.$message.info('纳税人识别号不能存在S');
				} else if (e.search('O') != -1) {
					this.$message.info('纳税人识别号不能存在O');
				} else if (e.search('V') != -1) {
					this.$message.info('纳税人识别号不能存在V');
				} else if (e.search('I') != -1) {
					this.$message.info('纳税人识别号不能存在I');
				} else if (e.search('Z') != -1) {
					this.$message.info('纳税人识别号不能存在Z');
				} else if (e != e.toUpperCase()) {
					this.$message.info('纳税人识别号不能存在小写字母');
				} else if (e.length != 18 && e.length != 20) {
					this.$message.info('纳税人识别号字数必须在18位和20位');
				}
				// if (e.length < 15) {
				// 	this.$message.info('纳税人识别号字数必须在15-20之间');
				// }
			},
			/* 购方信息 */

			closediaglr() {
				this.$emit('closediaglr', false);
			},
			querySearchAsync(queryString, cb) {
				console.log(queryString);
				console.log(cb);
			},
			createStateFilter(queryString) {
				console.log(queryString);
			},
			handleSelect(item) {
				console.log(item);
			},
			/*导入明细*/
			closediag() {
				console.log(1);
				this.importtk = false;
			}
		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
</style>